export default "__VITE_ASSET__BwabQ1pU__"